<template>
  <div>
    <p>Текущий домен: {{ currentURL }}</p>
    <v-checkbox v-model="cloudflare_settings" color="accent">
      <template #label>
        <p class="checkbox-label">Перенести настройки сервера в Cloudflare</p>
      </template>
    </v-checkbox>
    <div style="display: flex; align-items: center">
      <p style="margin: 0 15px 15px 0">Новый домен</p>
      <v-text-field
        v-model="newURL"
        color="accent"
        placeholder="https://casher8.win"
        style="margin: 0; padding: 0; max-width: 20%"
      />
      <v-btn color="primary" style="margin: 0 0 15px 25px" @click="saveURL">
        Сохранить
      </v-btn>
    </div>
    <v-snackbar
      v-model="snackbar"
      color="green"
    >
      <p style="margin: 0 auto">Успешно</p>
    </v-snackbar>
    <v-snackbar
      v-model="showError"
      color="red"
    >
      <p style="margin: 0 auto">Введите корректный домен</p>
    </v-snackbar>
  </div>
</template>

<script>
import { changeMainURL, getMainURL } from '../../api/multidomen'

export default {
  name: 'Multidomen',
  data () {
    return {
      currentURL: null,
      newURL: '',
      snackbar: false,
      showError: false,
      cloudflare_settings: false
    }
  },
  async mounted () {
    await this.loadURL()
  },
  methods: {
    async saveURL () {
      if (this.newURL)
        try {
          await changeMainURL(this.newURL, this.cloudflare_settings)
          this.snackbar = true
          this.newURL = ''
          await this.loadURL()
        } catch (e) {
          this.showError = true
        }
      else
        this.showError = true

    },
    async loadURL () {
      const res = await getMainURL()
      this.currentURL = res.data.url
    }
  }
}
</script>

<style scoped>
.checkbox-label {
  margin-bottom: 0;
  font-size: 14px;
}
</style>
